import { Box, Slider, Stack, Typography } from '@mui/material';
import { map } from 'lodash';
import React from 'react';
import { BooleanParam, useQueryParam } from 'use-query-params';

import { useProcedurePageLayout } from './useProcedurePageLayout';

export const ProcedurePageLayoutControls: React.FC<React.PropsWithChildren<{ compact?: boolean }>> = ({
  compact = false,
}) => {
  const [slidesMode] = useQueryParam('slidesMode', BooleanParam);
  const { cardsPerRow, setCardsPerRow, cardsPerRowOptions } = useProcedurePageLayout();
  const layoutUnitsLabel = slidesMode ? 'Slides' : 'Cases';
  const controlLabel = compact ? `${layoutUnitsLabel}/row` : `${layoutUnitsLabel} per row`;

  return (
    <Stack
      direction="row"
      spacing={compact ? 1 : 1.5}
      alignItems="center"
      sx={{ width: compact ? 200 : 260, px: compact ? 0.5 : 1, minHeight: 40 }}
    >
      <Typography variant="caption" color="text.secondary" sx={{ whiteSpace: 'nowrap' }}>
        {controlLabel}
      </Typography>

      <Box sx={{ flex: 1, minWidth: 0, display: 'flex', alignItems: 'center' }}>
        <Slider
          value={cardsPerRow}
          min={cardsPerRowOptions[0]}
          max={cardsPerRowOptions[cardsPerRowOptions.length - 1]}
          step={null}
          marks={map(cardsPerRowOptions, (casesPerRowOption) => ({
            value: casesPerRowOption,
            label: casesPerRowOption.toString(),
          }))}
          aria-label={controlLabel}
          data-cy="cards-per-row-slider"
          valueLabelDisplay={compact ? 'off' : 'auto'}
          sx={{
            my: 0,
            '& .MuiSlider-markLabel': {
              fontSize: compact ? '0.65rem' : '0.75rem',
            },
          }}
          onChange={(_, nextCasesPerRow) => {
            setCardsPerRow(Array.isArray(nextCasesPerRow) ? nextCasesPerRow[0] : Number(nextCasesPerRow));
          }}
        />
      </Box>
    </Stack>
  );
};
